import { getApiBaseUrl } from '../config/env';

export async function fetchPublicFeatures() {
  const res = await fetch(`${getApiBaseUrl()}/public/features`);
  if (!res.ok) {
    throw new Error('Failed to fetch features');
  }
  const json = await res.json();
  const payload = json.data || json;
  return payload.data || payload;
}

export async function fetchPublicFeatureBySlug(slug) {
  const res = await fetch(`${getApiBaseUrl()}/public/features/${encodeURIComponent(slug)}`);
  if (!res.ok) {
    throw new Error('Feature not found');
  }
  const json = await res.json();
  return json.data || json;
}
